import React from "react";
import "../index.css";
import loading from "../../../../assets/media/loader/dual-ring.svg";
const ConfirmToggleStatus = ({
  id,
  setConfirmingToggle,
  toggling,
  status,
  toggleStatus,
}) => {
  const handleToggleClick = async () => {
    toggleStatus();
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9991] w-screen h-screen bg-semi-trans backdrop-blur-sm">
      <div className="md:p-20px p-16px rounded-lg bg-white dark:bg-accent-600">
        {toggling ? (
          <img width={"30px"} src={loading} alt="" />
        ) : (
          <>
            <div className="mb-20px text-lg font-semibold text-accent-800 dark:text-accent-100">
              Toggle link status
            </div>
            <div className="">
              <label className="text-accent-400 dark:text-accent-200">
                {status === "active" ? (
                  <>
                    Are sure you want to{" "}
                    <strong className="text-accent-500 dark:text-accent-100">
                      {" "}
                      disable
                    </strong>{" "}
                    the link{" "}
                    <span className="text-primary-500 dark:text-primary-400">
                      #{id}
                    </span>{" "}
                    ?
                  </>
                ) : (
                  <>
                    Are sure you want to{" "}
                    <strong className="text-accent-500 dark:text-accent-100">
                      {" "}
                      active
                    </strong>{" "}
                    the link{" "}
                    <span className="text-primary-500 dark:text-primary-400">
                      #{id}
                    </span>{" "}
                    ?
                  </>
                )}
              </label>
            </div>
            <div className="flex mt-20px w-full justify-end gap-16px text-sm font-medium">
              <button
                type="button"
                className="bg-transparent border border-accent-100 py-2 px-16px rounded-md text-accent-400 dark:border-accent-400 dark:text-accent-200"
                onClick={() => setConfirmingToggle(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="bg-primary-400 dark:bg-primary-500 py-2 px-16px rounded-md text-white"
                onClick={() => handleToggleClick()}
              >
                Yes
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmToggleStatus;
